<template>
  <div>
    <poppins-card ref="targetElement" class="py-32">
      <div class="flex gap-16">
        <poppins-avatar :imageUrl="profileAccountData.photoUrl" size="mega" :name="profileAccountData.displayName" />
        <div>
          <h2 class="text-h3 break-all">{{ displayName }}</h2>
          <star-rating
            v-if="profileAccountData.reviews"
            :count="profileAccountData.reviews.totalReviewCount"
            :average="profileAccountData.reviews.starAggregate"
            class="cursor-pointer"
            @click="handleClick('star-rating-click')"
          />
        </div>
      </div>
      <icon-list :items="iconListItems" class="mt-8" :customMargin="16" @item-click="handleItemClick" />
      <poppins-button :value="buttonValue" class="w-full mt-16" size="large" />
    </poppins-card>
    <div
      v-if="scrolledPast"
      class="fixed left-0 bg-white w-full z-[60] p-16 border-t-1 border-b-1 border-solid border-grey-divider-subdued"
      :class="accountTypeInfo.isParent ? 'bottom-80' : 'bottom-0'"
    >
      <div class="flex gap-16">
        <poppins-avatar :imageUrl="profileAccountData.photoUrl" size="large" :name="profileAccountData.displayName" />
        <div>
          <p v-html="stickyRate" />
          <star-rating
            v-if="profileAccountData.reviews"
            :count="profileAccountData.reviews.totalReviewCount"
            :average="profileAccountData.reviews.starAggregate"
          />
        </div>
        <div v-if="accountTypeInfo.isParent" class="w-full text-right self-center mr-16">
          <provider-profile-favorite-sitter-button
            :favoritedSitter="favoritedSitter"
            :sitterAccountId="sitterAccountId"
            @favoritedSitterChange="favoritedSitterChange"
          />
        </div>
      </div>
      <poppins-button :value="buttonValue" class="w-full mt-16" size="medium" />
    </div>
  </div>
</template>

<script lang="ts">
import PoppinsCard from '@/components/card/Card.vue';
import PoppinsButton from '@/components/button/Button.vue';
import PoppinsAvatar from '@/components/avatar/Avatar.vue';
import StarRating from '@/components/star_rating/StarRating.vue';
import IconList from '@/components/icon_list/IconList.vue';
import ProviderProfileFavoriteSitterButton from './ProviderProfileFavoriteSitterButton.vue';

export default {
  name: 'ProviderProfileSitterSnapshot',
  components: { PoppinsCard, PoppinsButton, IconList, PoppinsAvatar, StarRating, ProviderProfileFavoriteSitterButton },
  props: {
    favoritedSitter: {
      default: false,
      type: Boolean,
    },
    rateDisplay: {
      required: true,
      type: String,
    },
    accountTypeInfo: {
      default: () => ({}),
      type: Object,
    },
    profileAccountData: {
      default: () => ({}),
      type: Object,
    },
    profileBelongsToViewer: {
      type: Boolean,
      default: false,
    },
    iconListItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      scrolledPast: false,
    };
  },
  computed: {
    sitterAccountId(): string {
      return this.profileAccountData?.id || '';
    },
    stickyRate(): any {
      return `<span class="text-body text-grey-text-subdued align-top">$</span> ${this.$props.rateDisplay}`;
    },
    displayName(): string {
      return this.profileAccountData?.displayName || '';
    },
    buttonValue(): string {
      return this.profileBelongsToViewer ? 'Edit Profile' : 'Contact Sitter';
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleClick(event) {
      this.$emit(event);
    },
    favoritedSitterChange(favoritedSitter) {
      this.$emit('favoritedSitterChange', favoritedSitter);
    },
    handleScroll() {
      const { targetElement } = this.$refs as any;
      const rect = targetElement?.$el.getBoundingClientRect();
      this.scrolledPast = rect?.bottom < 0;
    },
    handleItemClick(item) {
      this.$emit('item-click', item);
    },
  },
};
</script>
